import { Navigate, Outlet, useLocation } from 'react-router';

import { AuthLoadingScreen } from '@/components/layout/auth-loading';
import { useAuth } from '@/hooks/use-auth';
import { buildRedirectState } from '@/lib/redirect-path';

export function AuthGuard() {
  const {
    isAuthenticated,
    isLoading,
    onboardingRequest,
    requiresOnboarding,
    user,
  } = useAuth();
  const location = useLocation();
  const redirectState = buildRedirectState(location);

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (requiresOnboarding) {
    return (
      <Navigate
        to={onboardingRequest === null ? '/onboarding' : '/onboarding/pending'}
        replace
        state={redirectState}
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={redirectState} replace />;
  }

  if (
    user?.is_superadmin !== true
    && (user === null || user.membership_id === null)
    && location.pathname !== '/invitations'
  ) {
    return <Navigate to="/invitations" state={redirectState} replace />;
  }

  return <Outlet />;
}
